import { BaseService } from "./baseService";
class JobNoteService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "jobnote";
    }
}
export const jobNoteService = new JobNoteService();
//# sourceMappingURL=jobNoteService.js.map